export default __webpack_public_path__ + "static/media/igem-logo-light-bg.18616a6b.svg";